import React from 'react';
import styles from './Card.module.scss';
import classnames from 'classnames';

export interface CardInterface {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Card = (props: CardInterface) => {
  // ** The Card component activates the grid section: think of it like a stacked item spanning the whole grid - "grid-column: 1/13";
  return (
    <>
      <div className={classnames(styles.Card, props.className, 'bg-body')}>
        {props.children}
      </div>
    </>
  );
};

export default Card;
